// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0916c20e","455":"eccba58a","977":"684013a4"}[chunkId] + ".chunk.js";
};